export const validateMobileBarcode = (barcode: string): boolean => {
  const regex = /^\/[0-9A-Z.+-]{7}$/
  return regex.test(barcode)
}
